import { traverseError, isComponent } from '@/utils/stepper';
import { notificationsMixin } from './notifications';

/**
 * Mixin zakładek
 *
 */
export const stepperMixin = {
  mixins: [notificationsMixin],
  data() {
    return { activeStep: 0 };
  },
  methods: {
    // @vuese
    // Ustawia krok, jeżeli aktualna sekcja nie ma błędów
    setStep(step) {
      if (step >= this.activeStep) {
        const errors = this.validateStep(this.activeStep);
        if (errors.length) {
          this.notifyError('Należy poprawić błędy formularza.');
          return;
        }
      }
      this.activeStep = step;
    },
    // @vuese
    // Walidacja sekcji
    validateStep(stepToCheck) {
      let stepComponent = null;
      for (let i = 0; i < this.$children.length; i++) {
        const component = this.$children[i];
        if (isComponent(component, 'StepperStep', 'stepper-step')) {
          if (component.step === stepToCheck) {
            stepComponent = component;
            break;
          }
        }
      }

      if (!stepComponent) {
        return [];
      }

      const result = [];
      traverseError(stepComponent, result);
      return result;
    }
  }
};
